import e from "@dialpad/dialtone-tokens/layered/themes/tokens-dragonfruit-colors.css?inline";
//#region themes/dragonfruit.js
var t = {
	brand: {
		css: e,
		name: "dragonfruit"
	},
	material: { name: "iron" }
};
//#endregion
export { t as default };
